import React from "react";
import { fetchDispatchAlertCaptureConfig } from "../lib/systemConfigApi.js";
import {
  DISPATCH_ALERT_CAPTURE_STATUS_EVENT,
  subscribeDispatchCaptureStatus,
} from "../lib/dispatchCaptureStatusEvents.js";

export const DISPATCH_ALERT_CAPTURE_CONFIG_POLL_INTERVAL_MS = 15_000;

export default function useDispatchAlertCaptureConfigActive({
  enabled = false,
} = {}) {
  const [isActive, setIsActive] = React.useState(false);

  React.useEffect(() => {
    if (!enabled) {
      setIsActive(false);
      return undefined;
    }

    let cancelled = false;
    let intervalId = null;

    const loadConfig = async () => {
      try {
        const payload = await fetchDispatchAlertCaptureConfig();
        if (!cancelled) {
          setIsActive(payload?.is_active === true);
        }
      } catch {
        if (!cancelled) {
          setIsActive(false);
        }
      }
    };

    void loadConfig();
    const unsubscribeStatus = subscribeDispatchCaptureStatus(
      DISPATCH_ALERT_CAPTURE_STATUS_EVENT,
      (nextIsActive) => {
        if (!cancelled) {
          setIsActive(nextIsActive);
        }
      },
    );
    if (typeof window !== "undefined") {
      intervalId = window.setInterval(() => {
        if (typeof document === "undefined" || document.visibilityState !== "hidden") {
          void loadConfig();
        }
      }, DISPATCH_ALERT_CAPTURE_CONFIG_POLL_INTERVAL_MS);
    }

    const handleVisibilityChange = () => {
      if (typeof document !== "undefined" && document.visibilityState !== "hidden") {
        void loadConfig();
      }
    };
    if (typeof document !== "undefined") {
      document.addEventListener("visibilitychange", handleVisibilityChange);
    }

    return () => {
      cancelled = true;
      unsubscribeStatus();
      if (intervalId != null && typeof window !== "undefined") {
        window.clearInterval(intervalId);
      }
      if (typeof document !== "undefined") {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      }
    };
  }, [enabled]);

  return isActive;
}
